import React from "react";
import { ControlVisibility } from "../Interfaces/Interface";
interface EditQuestionModalProps { isOpen: boolean; question: any; isIntegratedChecklist: boolean; controls: string[]; controlVisibility: ControlVisibility; onChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void; onSave: () => void; onClose: () => void }
const EditQuestionModal: React.FC<EditQuestionModalProps> = ({ isOpen, question, isIntegratedChecklist, controlVisibility, onChange, onSave, onClose }) => {
    if (!isOpen || !question) return null;
    return (
        <div className="modal-overlay-checklist">
            <div className="modal-content-checklist">
                <h3>Edit Question</h3>
                <div className="modal-body-checklist">
                    <label>Question</label>
                    <textarea name="questionText" value={question.questionText || ""} onChange={onChange} />
                    <label>Expected Artifact</label>
                    <textarea name="expectedArtifact" value={question.expectedArtifact || ""} onChange={onChange} />
                    {!isIntegratedChecklist && (
                        <>
                            <label>Control/Practice Area</label>
                            <textarea name="practiceArea" value={question.practiceArea || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.pims && (
                        <>
                            <label>PIMS</label>
                            <textarea name="pims" value={question.pims || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.isms && (
                        <>
                            <label>ISMS</label>
                            <textarea name="isms" value={question.isms || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.bcms && (
                        <>
                            <label>BCMS</label>
                            <textarea name="bcms" value={question.bcms || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.cmmi && (
                        <>
                            <label>CMMI</label>
                            <textarea name="cmmi" value={question.cmmi || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.soc1 && (
                        <>
                            <label>SOC 1</label>
                            <textarea name="soc1" value={question.soc1 || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.soc2 && (
                        <>
                            <label>SOC 2</label>
                            <textarea name="soc2" value={question.soc2 || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.qms && (
                        <>
                            <label>QMS</label>
                            <textarea name="qms" value={question.qms || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.aims && (
                        <>
                            <label>AIMS</label>
                            <textarea name="aims" value={question.aims || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.erm && (
                        <>
                            <label>ERM</label>
                            <textarea name="erm" value={question.erm || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.itsm && (
                        <>
                            <label>ITSM</label>
                            <textarea name="itsm" value={question.itsm || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.ers && (
                        <>
                            <label>ERS</label>
                            <textarea name="ers" value={question.ers || ""} onChange={onChange} />
                        </>
                    )}
                    {isIntegratedChecklist && controlVisibility.ohs && (
                        <>
                            <label>OHS</label>
                            <textarea name="ohs" value={question.ohs || ""} onChange={onChange} />
                        </>
                    )}
                </div>
                <div className="buttons">
                    <button className="cancelbutton" onClick={onClose}>Cancel</button>
                    <button className="savebutton" onClick={onSave}>Save</button>
                </div>
            </div>
        </div>
    );
};
export default EditQuestionModal;